import { MimeTypesEnum } from '@interfaces/../../models/enums/mime-type.enum';

export class MimeTypeExtractor {
  static getMimeType(mimeTypeString: string = null): MimeTypesEnum {
    switch (mimeTypeString) {
      case 'application/pdf':
        return MimeTypesEnum.PDF;
      default:
        return MimeTypesEnum.UNKNOWN;
    }
  }
}
